export default "__VITE_ASSET__C$X18QHd__"